export class IPagination {
  page: number;
  limit: number;
}

export class IQueryPaginationDto {
  page?: number;
  limit?: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  orderBy?: 'asc' | 'desc' | Record<string, any>;
}
